export const CHECKOUT_URL = 'https://voleypro.impultienda.ar/';
